import type { GoodsDetailContentKeys } from '../types/GoodsDetailContentKeys';
import Animated from 'react-native-reanimated';
import { List } from '@banhala/ui-kit';
export const AnimatedList = Animated.createAnimatedComponent(
  List<GoodsDetailContentKeys>,
);
